import React from 'react'
import { components, useTranslation } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import UaeMpciKeys from 'src/constants/locale/key/UaeMpci'
import { Box, IconButton, Tooltip, Table, TableHead, TableBody, TableRow, TableCell } from '@material-ui/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const {
  button: { CngButton }
} = components

function SplitGoodsTable(props) {
  const { data, onAddSplitGoods, onEditSplitGoods, onDeleteSplitGoods, showNotification } = props
  const { translate } = useTranslation(Namespace.UAE_MPCI)

  const goodsItemNumber = translate(Namespace.UAE_MPCI, UaeMpciKeys.SplitGoods.GOODS_ITEM_NUMBER)
  const containerNumber = translate(Namespace.UAE_MPCI, UaeMpciKeys.SplitGoods.CONTAINER_NUMBER)
  const packageQuantity = translate(Namespace.UAE_MPCI, UaeMpciKeys.SplitGoods.PACKAGE_QUANTITY)

  return (
    <Box>
      <Box display="flex" justifyContent="flex-end" mb={1}>
        <CngButton
          color='primary'
          onClick={onAddSplitGoods}
          size='small'
          startIcon={<FontAwesomeIcon icon={['fal', 'plus']} />}
        >
          Add Split Goods
        </CngButton>
      </Box>
      {data && data.length > 0 && (
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>{goodsItemNumber}</TableCell>
              <TableCell>{containerNumber}</TableCell>
              <TableCell>{packageQuantity}</TableCell>
              <TableCell align="right">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((item, index) => (
              <TableRow key={index}>
                <TableCell>{item.goodsItemNumber}</TableCell>
                <TableCell>{item.containerNumber}</TableCell>
                <TableCell>{item.packageQuantity}</TableCell>
                <TableCell align="right">
                  <Tooltip title="Edit">
                    <IconButton size="small" onClick={() => onEditSplitGoods(item)}>
                      <FontAwesomeIcon icon={['fal', 'pen']} />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Delete">
                    <IconButton size="small" onClick={() => onDeleteSplitGoods(item)}>
                      <FontAwesomeIcon icon={['fal', 'trash']} />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </Box>
  )
}

export default SplitGoodsTable
